import {Flex, Text, Heading} from '@chakra-ui/react';

const LoremIpsum = () => {
  return (
    <Flex direction="column" align="center">
      <Heading>Lorem Ipsum</Heading>
      <Text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut ut volutpat
        metus. Phasellus tempor non nunc venenatis ultrices. Sed imperdiet at
        nisl non bibendum. Morbi id neque enim. Cras mattis justo eget libero
        aliquam interdum. Lorem ipsum dolor sit amet, consectetur adipiscing
        elit. Class aptent taciti sociosqu ad litora torquent per conubia
        nostra, per inceptos himenaeos. Vestibulum scelerisque vel elit vel
        scelerisque. Etiam et urna quis nisl aliquet bibendum.
      </Text>
      <Text>
        Mauris interdum, enim eget elementum lacinia, ex velit scelerisque
        ligula, sed hendrerit ex ipsum eget turpis. Pellentesque porttitor nunc
        ac bibendum semper. Suspendisse faucibus finibus sapien, at sollicitudin
        ex convallis in. Nulla tempus luctus enim, eu cursus nisl pretium ac.
        Donec sed dui sollicitudin, laoreet augue at, semper libero. Cras nec
        erat dapibus, tempus justo in, ultricies dolor. Mauris in ex feugiat,
        tempor eros vel, lacinia erat.
      </Text>
      <Text>
        Nam vestibulum feugiat ipsum, eu pharetra quam accumsan id. Vivamus
        ultrices mauris at urna porta dignissim. Etiam condimentum nulla et
        turpis egestas dignissim. Maecenas in metus ac metus vehicula vestibulum
        eu et lacus. Nunc a eros ligula. Ut in ipsum sed metus rutrum vulputate
        ac in metus. Nullam volutpat posuere condimentum. Integer dapibus, augue
        lacinia pulvinar elementum, erat tellus cursus enim, vel dapibus augue
        nisl in magna. Nunc justo mi, bibendum ut luctus vel, luctus et eros.
        Morbi cursus massa urna, eu rhoncus nisl imperdiet non. Morbi tincidunt
        maximus mauris, et luctus est lacinia posuere. Pellentesque consequat,
        augue sed commodo feugiat, eros velit vulputate metus, eget vehicula
        felis elit quis nibh. Curabitur eu vulputate ante. Aliquam commodo dolor
        ut eleifend congue. Quisque vitae elit porttitor, pulvinar orci sit
        amet, sollicitudin lorem. Integer id erat ut tellus auctor pellentesque
        sit amet vitae ex.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>
      <Text>
        Curabitur placerat sed mauris ac tincidunt. Aliquam ornare tempus enim
        id scelerisque. Etiam pellentesque hendrerit pulvinar. Cras hendrerit
        erat quis urna hendrerit fermentum laoreet at orci. Praesent suscipit
        odio lacus, quis pharetra metus placerat in. Integer ornare tempus
        lacinia. Mauris vulputate accumsan malesuada. Morbi a orci eget nulla
        volutpat facilisis.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>
      <Text>
        Curabitur placerat sed mauris ac tincidunt. Aliquam ornare tempus enim
        id scelerisque. Etiam pellentesque hendrerit pulvinar. Cras hendrerit
        erat quis urna hendrerit fermentum laoreet at orci. Praesent suscipit
        odio lacus, quis pharetra metus placerat in. Integer ornare tempus
        lacinia. Mauris vulputate accumsan malesuada. Morbi a orci eget nulla
        volutpat facilisis.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>
      <Text>
        Curabitur placerat sed mauris ac tincidunt. Aliquam ornare tempus enim
        id scelerisque. Etiam pellentesque hendrerit pulvinar. Cras hendrerit
        erat quis urna hendrerit fermentum laoreet at orci. Praesent suscipit
        odio lacus, quis pharetra metus placerat in. Integer ornare tempus
        lacinia. Mauris vulputate accumsan malesuada. Morbi a orci eget nulla
        volutpat facilisis.
      </Text>
      <Text>
        Mauris interdum, enim eget elementum lacinia, ex velit scelerisque
        ligula, sed hendrerit ex ipsum eget turpis. Pellentesque porttitor nunc
        ac bibendum semper. Suspendisse faucibus finibus sapien, at sollicitudin
        ex convallis in. Nulla tempus luctus enim, eu cursus nisl pretium ac.
        Donec sed dui sollicitudin, laoreet augue at, semper libero. Cras nec
        erat dapibus, tempus justo in, ultricies dolor. Mauris in ex feugiat,
        tempor eros vel, lacinia erat.
      </Text>
      <Text>
        Nam vestibulum feugiat ipsum, eu pharetra quam accumsan id. Vivamus
        ultrices mauris at urna porta dignissim. Etiam condimentum nulla et
        turpis egestas dignissim. Maecenas in metus ac metus vehicula vestibulum
        eu et lacus. Nunc a eros ligula. Ut in ipsum sed metus rutrum vulputate
        ac in metus. Nullam volutpat posuere condimentum. Integer dapibus, augue
        lacinia pulvinar elementum, erat tellus cursus enim, vel dapibus augue
        nisl in magna. Nunc justo mi, bibendum ut luctus vel, luctus et eros.
        Morbi cursus massa urna, eu rhoncus nisl imperdiet non. Morbi tincidunt
        maximus mauris, et luctus est lacinia posuere. Pellentesque consequat,
        augue sed commodo feugiat, eros velit vulputate metus, eget vehicula
        felis elit quis nibh. Curabitur eu vulputate ante. Aliquam commodo dolor
        ut eleifend congue. Quisque vitae elit porttitor, pulvinar orci sit
        amet, sollicitudin lorem. Integer id erat ut tellus auctor pellentesque
        sit amet vitae ex.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>{' '}
      <Text>
        Mauris interdum, enim eget elementum lacinia, ex velit scelerisque
        ligula, sed hendrerit ex ipsum eget turpis. Pellentesque porttitor nunc
        ac bibendum semper. Suspendisse faucibus finibus sapien, at sollicitudin
        ex convallis in. Nulla tempus luctus enim, eu cursus nisl pretium ac.
        Donec sed dui sollicitudin, laoreet augue at, semper libero. Cras nec
        erat dapibus, tempus justo in, ultricies dolor. Mauris in ex feugiat,
        tempor eros vel, lacinia erat.
      </Text>
      <Text>
        Nam vestibulum feugiat ipsum, eu pharetra quam accumsan id. Vivamus
        ultrices mauris at urna porta dignissim. Etiam condimentum nulla et
        turpis egestas dignissim. Maecenas in metus ac metus vehicula vestibulum
        eu et lacus. Nunc a eros ligula. Ut in ipsum sed metus rutrum vulputate
        ac in metus. Nullam volutpat posuere condimentum. Integer dapibus, augue
        lacinia pulvinar elementum, erat tellus cursus enim, vel dapibus augue
        nisl in magna. Nunc justo mi, bibendum ut luctus vel, luctus et eros.
        Morbi cursus massa urna, eu rhoncus nisl imperdiet non. Morbi tincidunt
        maximus mauris, et luctus est lacinia posuere. Pellentesque consequat,
        augue sed commodo feugiat, eros velit vulputate metus, eget vehicula
        felis elit quis nibh. Curabitur eu vulputate ante. Aliquam commodo dolor
        ut eleifend congue. Quisque vitae elit porttitor, pulvinar orci sit
        amet, sollicitudin lorem. Integer id erat ut tellus auctor pellentesque
        sit amet vitae ex.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>{' '}
      <Text>
        Mauris interdum, enim eget elementum lacinia, ex velit scelerisque
        ligula, sed hendrerit ex ipsum eget turpis. Pellentesque porttitor nunc
        ac bibendum semper. Suspendisse faucibus finibus sapien, at sollicitudin
        ex convallis in. Nulla tempus luctus enim, eu cursus nisl pretium ac.
        Donec sed dui sollicitudin, laoreet augue at, semper libero. Cras nec
        erat dapibus, tempus justo in, ultricies dolor. Mauris in ex feugiat,
        tempor eros vel, lacinia erat.
      </Text>
      <Text>
        Nam vestibulum feugiat ipsum, eu pharetra quam accumsan id. Vivamus
        ultrices mauris at urna porta dignissim. Etiam condimentum nulla et
        turpis egestas dignissim. Maecenas in metus ac metus vehicula vestibulum
        eu et lacus. Nunc a eros ligula. Ut in ipsum sed metus rutrum vulputate
        ac in metus. Nullam volutpat posuere condimentum. Integer dapibus, augue
        lacinia pulvinar elementum, erat tellus cursus enim, vel dapibus augue
        nisl in magna. Nunc justo mi, bibendum ut luctus vel, luctus et eros.
        Morbi cursus massa urna, eu rhoncus nisl imperdiet non. Morbi tincidunt
        maximus mauris, et luctus est lacinia posuere. Pellentesque consequat,
        augue sed commodo feugiat, eros velit vulputate metus, eget vehicula
        felis elit quis nibh. Curabitur eu vulputate ante. Aliquam commodo dolor
        ut eleifend congue. Quisque vitae elit porttitor, pulvinar orci sit
        amet, sollicitudin lorem. Integer id erat ut tellus auctor pellentesque
        sit amet vitae ex.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>{' '}
      <Text>
        Mauris interdum, enim eget elementum lacinia, ex velit scelerisque
        ligula, sed hendrerit ex ipsum eget turpis. Pellentesque porttitor nunc
        ac bibendum semper. Suspendisse faucibus finibus sapien, at sollicitudin
        ex convallis in. Nulla tempus luctus enim, eu cursus nisl pretium ac.
        Donec sed dui sollicitudin, laoreet augue at, semper libero. Cras nec
        erat dapibus, tempus justo in, ultricies dolor. Mauris in ex feugiat,
        tempor eros vel, lacinia erat.
      </Text>
      <Text>
        Nam vestibulum feugiat ipsum, eu pharetra quam accumsan id. Vivamus
        ultrices mauris at urna porta dignissim. Etiam condimentum nulla et
        turpis egestas dignissim. Maecenas in metus ac metus vehicula vestibulum
        eu et lacus. Nunc a eros ligula. Ut in ipsum sed metus rutrum vulputate
        ac in metus. Nullam volutpat posuere condimentum. Integer dapibus, augue
        lacinia pulvinar elementum, erat tellus cursus enim, vel dapibus augue
        nisl in magna. Nunc justo mi, bibendum ut luctus vel, luctus et eros.
        Morbi cursus massa urna, eu rhoncus nisl imperdiet non. Morbi tincidunt
        maximus mauris, et luctus est lacinia posuere. Pellentesque consequat,
        augue sed commodo feugiat, eros velit vulputate metus, eget vehicula
        felis elit quis nibh. Curabitur eu vulputate ante. Aliquam commodo dolor
        ut eleifend congue. Quisque vitae elit porttitor, pulvinar orci sit
        amet, sollicitudin lorem. Integer id erat ut tellus auctor pellentesque
        sit amet vitae ex.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>{' '}
      <Text>
        Mauris interdum, enim eget elementum lacinia, ex velit scelerisque
        ligula, sed hendrerit ex ipsum eget turpis. Pellentesque porttitor nunc
        ac bibendum semper. Suspendisse faucibus finibus sapien, at sollicitudin
        ex convallis in. Nulla tempus luctus enim, eu cursus nisl pretium ac.
        Donec sed dui sollicitudin, laoreet augue at, semper libero. Cras nec
        erat dapibus, tempus justo in, ultricies dolor. Mauris in ex feugiat,
        tempor eros vel, lacinia erat.
      </Text>
      <Text>
        Nam vestibulum feugiat ipsum, eu pharetra quam accumsan id. Vivamus
        ultrices mauris at urna porta dignissim. Etiam condimentum nulla et
        turpis egestas dignissim. Maecenas in metus ac metus vehicula vestibulum
        eu et lacus. Nunc a eros ligula. Ut in ipsum sed metus rutrum vulputate
        ac in metus. Nullam volutpat posuere condimentum. Integer dapibus, augue
        lacinia pulvinar elementum, erat tellus cursus enim, vel dapibus augue
        nisl in magna. Nunc justo mi, bibendum ut luctus vel, luctus et eros.
        Morbi cursus massa urna, eu rhoncus nisl imperdiet non. Morbi tincidunt
        maximus mauris, et luctus est lacinia posuere. Pellentesque consequat,
        augue sed commodo feugiat, eros velit vulputate metus, eget vehicula
        felis elit quis nibh. Curabitur eu vulputate ante. Aliquam commodo dolor
        ut eleifend congue. Quisque vitae elit porttitor, pulvinar orci sit
        amet, sollicitudin lorem. Integer id erat ut tellus auctor pellentesque
        sit amet vitae ex.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>{' '}
      <Text>
        Mauris interdum, enim eget elementum lacinia, ex velit scelerisque
        ligula, sed hendrerit ex ipsum eget turpis. Pellentesque porttitor nunc
        ac bibendum semper. Suspendisse faucibus finibus sapien, at sollicitudin
        ex convallis in. Nulla tempus luctus enim, eu cursus nisl pretium ac.
        Donec sed dui sollicitudin, laoreet augue at, semper libero. Cras nec
        erat dapibus, tempus justo in, ultricies dolor. Mauris in ex feugiat,
        tempor eros vel, lacinia erat.
      </Text>
      <Text>
        Nam vestibulum feugiat ipsum, eu pharetra quam accumsan id. Vivamus
        ultrices mauris at urna porta dignissim. Etiam condimentum nulla et
        turpis egestas dignissim. Maecenas in metus ac metus vehicula vestibulum
        eu et lacus. Nunc a eros ligula. Ut in ipsum sed metus rutrum vulputate
        ac in metus. Nullam volutpat posuere condimentum. Integer dapibus, augue
        lacinia pulvinar elementum, erat tellus cursus enim, vel dapibus augue
        nisl in magna. Nunc justo mi, bibendum ut luctus vel, luctus et eros.
        Morbi cursus massa urna, eu rhoncus nisl imperdiet non. Morbi tincidunt
        maximus mauris, et luctus est lacinia posuere. Pellentesque consequat,
        augue sed commodo feugiat, eros velit vulputate metus, eget vehicula
        felis elit quis nibh. Curabitur eu vulputate ante. Aliquam commodo dolor
        ut eleifend congue. Quisque vitae elit porttitor, pulvinar orci sit
        amet, sollicitudin lorem. Integer id erat ut tellus auctor pellentesque
        sit amet vitae ex.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>{' '}
      <Text>
        Mauris interdum, enim eget elementum lacinia, ex velit scelerisque
        ligula, sed hendrerit ex ipsum eget turpis. Pellentesque porttitor nunc
        ac bibendum semper. Suspendisse faucibus finibus sapien, at sollicitudin
        ex convallis in. Nulla tempus luctus enim, eu cursus nisl pretium ac.
        Donec sed dui sollicitudin, laoreet augue at, semper libero. Cras nec
        erat dapibus, tempus justo in, ultricies dolor. Mauris in ex feugiat,
        tempor eros vel, lacinia erat.
      </Text>
      <Text>
        Nam vestibulum feugiat ipsum, eu pharetra quam accumsan id. Vivamus
        ultrices mauris at urna porta dignissim. Etiam condimentum nulla et
        turpis egestas dignissim. Maecenas in metus ac metus vehicula vestibulum
        eu et lacus. Nunc a eros ligula. Ut in ipsum sed metus rutrum vulputate
        ac in metus. Nullam volutpat posuere condimentum. Integer dapibus, augue
        lacinia pulvinar elementum, erat tellus cursus enim, vel dapibus augue
        nisl in magna. Nunc justo mi, bibendum ut luctus vel, luctus et eros.
        Morbi cursus massa urna, eu rhoncus nisl imperdiet non. Morbi tincidunt
        maximus mauris, et luctus est lacinia posuere. Pellentesque consequat,
        augue sed commodo feugiat, eros velit vulputate metus, eget vehicula
        felis elit quis nibh. Curabitur eu vulputate ante. Aliquam commodo dolor
        ut eleifend congue. Quisque vitae elit porttitor, pulvinar orci sit
        amet, sollicitudin lorem. Integer id erat ut tellus auctor pellentesque
        sit amet vitae ex.
      </Text>
      <Text>
        Duis auctor sapien ullamcorper fringilla condimentum. Curabitur euismod
        neque quis lacus aliquet fermentum. In dolor diam, consectetur eget
        lorem sed, fringilla commodo nisi. Nam gravida dui nisl, ut euismod erat
        faucibus a. Nulla volutpat, erat id accumsan bibendum, enim purus
        ullamcorper velit, a finibus nunc sem id tellus. Curabitur ut risus
        molestie, aliquet dui eget, fringilla massa. Vestibulum ante ipsum
        primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Vivamus consectetur elit sit amet nisl eleifend posuere. Etiam pretium,
        ipsum vitae ullamcorper porta, mi nisl molestie lectus, at vehicula
        sapien nibh quis nulla. Etiam pharetra varius sollicitudin.
      </Text>
    </Flex>
  );
};

export default LoremIpsum;
